import React, { useContext } from "react";

import { Transition } from "@headlessui/react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import ConnectionContext from "@/connectionContext";

ConnectionBar.propTypes = {
  tileDisplay: PropTypes.bool,
};

export default function ConnectionBar() {
  const { t } = useTranslation();
  const { connected } = useContext(ConnectionContext);

  if (!location.pathname) {
    return null;
  }

  return (
    <Transition
      appear={true}
      show={!connected}
      className="transition-all"
      enterFrom="opacity-0 -translate-y-8"
      enterTo="opacity-100 translate-y-0 bg-red-500"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 -translate-y-8"
    >
      <div className="flex justify-center items-center w-full h-8 font-semibold text-white bg-red-500">
        {t("common.disconnected")}
      </div>
    </Transition>
  );
}
